import React from "react"
import LaunchIcon from "@mui/icons-material/Launch"
import carInsureType from "../../../images/car_insurance_type.png"
import styles from "../ModalDefault.module.scss"

const KOME = <span style={{ fontFamily: "Meiryo, メイリオ" }}>※</span>
const launchStyle = {
  height: "18px",
  verticalAlign: "bottom",
  marginBottom: "2px",
  marginLeft: "-2px",
  display: "inline-block"
}
const Launch = () => (
  <span style={launchStyle}>
    <LaunchIcon style={{ height: "inherit" }} />
  </span>
)

export const liveTogether = () => {
  return (
    <div className={styles.liveTogether}>
      同居のお子さまは、「お車を主に使用される方（記名被保険者）またはその配偶者」と同居されている以下の方をいいます。
      <ul>
        <li>「記名被保険者またはその配偶者」のお子さま</li>
        <li>「記名被保険者またはその配偶者」のお子さまの配偶者</li>
      </ul>
    </div>
  )
}

export const servant = () => {
  return (
    <div className={styles.servant}>
      使用人は、「お車を主に使用される方（記名被保険者）またはその配偶者」の業務（家事は除きます）に従事する方で、お車を運転される方をいいます。
      <br />
      なお、使用人の中に、配偶者・別居の未婚のお子さまは含みません。
    </div>
  )
}

export const gradeCondition = () => {
  return (
    <div className={styles.gradeCondition}>
      2台目以降の車に初めて自動車保険を契約する場合、特定の条件を満たせばセカンドカー割引（7S等級）が適用されます。
      <br />
      主な条件は以下のとおりです。
      <ul>
        <li>①1台目の車に適用されている等級が11等級以上であること。</li>
        <li>②1台目および2台目以降の車がいずれも自家用8車種であること。</li>
        <li>
          ③2台目以降の契約の主に運転される方（記名被保険者）が個人で、かつ、1台目の契約の下記aからcのいずれかであること。
        </li>
        <li>
          ④2台目以降の契約の車両所有者が個人で、かつ、1台目の契約の下記aからdのいずれかであること。
          （所有者がディーラー、リース業者（1年以上のリース）の場合には使用者を所有者とみなします。）など
        </li>
      </ul>
      <ul>
        <li>a：記名被保険者</li>
        <li>b：記名被保険者の配偶者</li>
        <li>c：aまたはbの同居の親族</li>
        <li>d：車両所有者</li>
      </ul>
      <br />
      <br />
      詳細は
      <a
        href="https://faq-ins-saison.dga.jp/car/otona/faq_detail.html?cid=WHP001&id=2300&category=142"
        target="_blank"
        rel="noreferrer"
      >
        こちら
      </a>
    </div>
  )
}
export const personalAndObject = () => {
  return (
    <div>
      ご契約のお車を運転中の事故で他人を死傷させてしまった、他人の車やモノを壊してしまったなどで、法律上の損害賠償責任を負担する場合に、補償されます。専任担当者による示談代行サービスつきで保険金額は無制限です。
      <br />
      <br />
      詳細は
      <a href="https://www.sompo-direct.co.jp/otona/compensate/personal/?cid=WHP001" target="_blank" rel="noreferrer">
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const uninsuredCarAccidents = () => {
  return (
    <div>
      保険に加入していない車との事故で死亡または後遺障害を負い、相手から十分な損害賠償が受けられない場合に補償されます。
      <br />
      被害額が高額になるケースがあるため、「おとなの自動車保険」では保険金額を無制限にしています。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/human/uninsured.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const otherCarDriving = () => {
  return (
    <div>
      借りた車を運転中に事故を起こしてしまった場合に、ご契約の自動車の契約内容に従い、ご自身の保険から優先して保険金が支払われます。
      <br />
      「おとなの自動車保険」では借りた車の運転中のリスクに備えて、他車運転特約を基本補償にセットしています。
      <br />
      <br />
      詳細は
      <a href="https://www.sompo-direct.co.jp/otona/compensate/personal/?cid=WHP001" target="_blank" rel="noreferrer">
        こちら
      </a>
    </div>
  )
}
export const victimSaving = () => {
  return (
    <div>
      ご契約のお車の欠陥・不正アクセスなどにより人身事故または物損事故が発生し、被保険者に法律上の損害賠償責任がなかったことが確定したときに、被害者を救済するために被保険者が支出した費用に対して保険金をお支払いします。
      <br />
      <br />
      詳細は
      <a
        href="https://faq-ins-saison.dga.jp/car_h/otona/faq_detail.html?id=17468&category=1147"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const EV_HV = () => {
  return (
    <div>
      ご契約のお車が電気自動車、ハイブリッド車の場合、保険料が1,200円割引となります。
      <br />
      <br />
      {KOME}
      保険始期日の属する月が初度登録年月（初度検査年月）から13か月以内の場合に対象となります。
      <br />
      {KOME}
      自家用（普通・小型・軽四輪）乗用車のみ対象となります。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const personalInjury = () => {
  return (
    <div>
      ご契約のお車に搭乗中の方が、自動車事故により死傷した場合に、治療費の実費や、働けない間の収入、精神的損害などを補償します。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/human/human.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const passengerInjury = () => {
  return (
    <div>
      ご契約のお車に搭乗中の方が、自動車事故により死傷した場合や後遺障害を負った場合に、あらかじめ定められた金額を補償します。
      <br />
      おケガの治療中であっても、ケガの症状により保険金をスピーディにお支払いしますので、入院費や通院費などの当座の費用が必要となった場合でも安心です。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/human/passenger.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const objectTotalLossBefore = () => {
  return (
    <div>
      事故を起こした相手の車の年式が古い場合、時価額よりも修理代の方が高くなることがあります。
      <br />
      この特約により、対物賠償で不足する分が最大50万円まで補償されます。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/personal/repair.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const objectTotalLoss = () => {
  return (
    <div>
      事故を起こした相手の車の年式が古い場合、時価額よりも修理代の方が高くなることがあります。
      <br />
      この特約により、対物賠償で不足する分が最大50万円まで補償されます。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/personal/repair.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const roadAssistance = () => {
  return (
    <div>
      ご契約のお車が事故・故障・トラブルにより走行不能となった場合に必要な、応急処置費用、レッカーなどの運搬費用、宿泊費用、移動費用が補償されます。
      <br />
      また、燃料切れ時の給油サービスなどがセットされます。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/other/road_assist.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const lawyerCost = () => {
  return (
    <div>
      主に運転される方（記名被保険者）やそのご家族の方などが、自動車にかかわる人身事故や物損事故にあい、損害賠償請求を行う場合に生じる弁護士費用などや、法律相談をする場合の費用を補償します。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/other/lawyer.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const personalLiability = () => {
  return (
    <div>
      自動車事故以外の日常生活の事故により、お客さまやご家族の方が他人にケガをさせたり、他人の財物に損害を与えたりすることによって、法律上の損害賠償責任を負った場合に補償されます。
      <br />
      「保険金額が無制限」であり、「専任担当者による示談代行サービス」もついているため、ぜひ加入されることをお勧めします。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/other/individual_personal.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const bicycleDamage = () => {
  return (
    <div>
      お客さまやご家族の方が自転車走行中に転倒したり、歩行中に他人の乗っている自転車とぶつかり、死傷された場合に、入院、死亡、後遺障害の保険金についてお支払いします。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/other/bicycle.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const accessaryDiscount = () => {
  return (
    <div>
      衝突、接触、火災、盗難などの事故でご契約のお車に損害が生じ、その直接の結果としてお車に「積載中の動産（衣類、カメラ、ゴルフ道具など）」に損害が生じた場合に、時価額を限度に補償されます。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/other/movables.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const paper = () => {
  return (
    <div>
      すべてのお客さまにデジタル保険証券を無料で発行いたします。
      <br />
      デジタル保険証券はマイページ上で確認・印刷できるPDF形式の保険証券です。
      <br />
      <br />
      詳細は
      <a
        href="https://faq-ins-saison.dga.jp/car_h/otona/faq_detail.html?id=15137&_ga=2.217006034.535278268.1622022146-526172691.1613436998&_gl=1*ccgetn*_ga*NTI2MTcyNjkxLjE2MTM0MzY5OTg.*_ga_KK81HCGBTG*MTYyMjAxOTQ0MC4xMjYuMS4xNjIyMDIzMDMyLjA."
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const familyBike = () => {
  return (
    <div>
      主に運転される方（記名被保険者）やそのご家族の方が、原動機付自転車（125cc以下の二輪車、50cc以下の三輪以上の車）を運転中の事故により生じた損害（対人賠償・対物賠償・自損傷害または人身傷害）について、主契約と同じ条件（自損タイプの場合は約款の限度額）にて補償されます。
      <br />
      付帯される場合は、当社試算サイトからご試算ください。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/other/family_bike.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const forYourCarType = () => {
  return (
    <div>
      ご契約のお車が、事故により損害を被ったり、盗難にあった場合に保険金を受け取ることができます。タイプごとに以下の補償範囲となります。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/vehicle/vehicle.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
      {/* 画像の差し替え
      ライトプランの表記をミニマムプランに変更した画像に差し替える */}
      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <img src={carInsureType} alt="車両保険タイプ" style={{ width: "100%", maxWidth: "300px" }} />
      </div>
    </div>
  )
}
export const forYourCarTotalLossComp = () => {
  return (
    <div>
      ご契約のお車が事故により破損し、修理費が車両保険の保険金額を上回り、実際に修理された場合は、保険金額を超える部分の修理費に対して50万円を限度に保険金をお支払いします。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/vehicle/total_loss.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const forYourCarOriginalPriceComp = () => {
  return (
    <div>
      新車で購入したお車が全損になった場合や、修理費が新車価格相当額の50%以上となり、お車を再取得された場合に、新車の再取得費用をお支払いします。（新車価格相当額が上限）
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/vehicle/new_price.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const forYourCarReplacementCar = () => {
  return (
    <div>
      ご契約の車が車両保険の補償対象となる事故によって損害を被った場合、修理期間中などのレンタカー費用が支払われます。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/compensate/vehicle/period_cost.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const internetDiscount = () => {
  return (
    <div>
      インターネットでご加入いただくことで適用される割引です。おとなの自動車保険は、パソコンからでも、スマートフォンからでも、いつでもどこからでも、ご契約いただくことができます。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const secondCar = () => {
  return (
    <div>
      おとなの自動車保険にご契約中のお客さまが、同一マイページから新たに２台目以降のお車をご契約される場合、「おとなの2台目割引」が適用されます。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const earlyPaymentDiscountThirtyDays = () => {
  return (
    <div>
      保険の開始日の前日から数えて30日前までにご契約を完了されたお客さまへ「早割30日」を適用し、保険料を400円（分割払は年間360円）割引します。
      <br />
      なお、本サイトでは、保険の開始日をお見積り日から30日後に設定しています。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const earlyPaymentDiscountFiftyDays = () => {
  return (
    <div>
      保険の開始日の前日から数えて50日前までにご契約を完了されたお客さまへ「早割50日」を適用し、保険料を600円割引します。
      <br />
      なお、本サイトでは、保険の開始日をお見積り日から30日後に設定しています。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const ALSOK = () => {
  return (
    <div>
      もしもの事故の時、ALSOK隊員がかけつけてあなたに寄り添い、事故対応をサポートします。
      <br />
      ALSOKは全国約2,300か所（2024年4月時点）の拠点を持っており、ALSOKと提携することで、全国どこでも迅速に安心を提供できる体制を実現しました。
      <br />
      <br />
      詳細は
      <a href="https://www.sompo-direct.co.jp/otona/service/alsok/?cid=WHP001" target="_blank" rel="noreferrer">
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const newCarDiscount = () => {
  return (
    <div>
      ご契約のお車が自家用（普通・小型・軽四輪）乗用車で、保険の開始日の属する年月がお車の初度登録年月（または初度検査年月）の翌月から49か月以内の場合は、「新車割引」として保険料を割引します。
      <br />
      <br />
      詳細は
      <a
        href="https://faq-ins-saison.dga.jp/car_h/otona/faq_detail.html?id=1405&page=3&_ga=2.136311992.885200671.1622159845-526172691.1613436998&_gl=1*1sg2xgg*_ga*NTI2MTcyNjkxLjE2MTM0MzY5OTg.*_ga_KK81HCGBTG*MTYyMjE3NTUyMy4xMjkuMC4xNjIyMTc1NTIzLjA."
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const ASVDiscount = () => {
  return (
    <div>
      お車にメーカー純正のAEB（衝突被害軽減ブレーキ）が搭載されており、かつ、一定の条件を満たす場合に適用される割引です。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const GoldLicenseDiscount = () => {
  return (
    <div>
      保険開始日時点で、お車を主に使用される方がゴールド免許をお持ちの場合は、ゴールド免許割引が適用されます。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const Grade20NoClaimDiscount = () => {
  return (
    <div>
      現在のご契約、および、おとなの自動車保険のご契約の等級が20等級であることなど、一定の条件を満たす場合に適用される割引です。
      <br />
      <br />
      ※ 本見積りでは適用条件を満たしているかの確認が十分ではないため、20等級継続割引を適用せずにお見積りしています。
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
export const NoAccidentDiscount = () => {
  return (
    <div>
      現在のご契約で、保険金をお支払いする事故※がなかった場合など、一定の条件を満たす場合に適用される割引です。
      <br />
      （※ノーカウント事故は除きます。）
      <br />
      <br />
      詳細は
      <a
        href="https://www.sompo-direct.co.jp/otona/insurance/discount.html?cid=WHP001"
        target="_blank"
        rel="noreferrer"
      >
        こちら
        <Launch />
      </a>
    </div>
  )
}
